// src/components/LeadsHeader.jsx
import React, { useEffect, useState } from "react";
import axios                   from "axios";
import { FiDownload, FiPlus, FiFilter } from "react-icons/fi";
import { Link }                from "react-router-dom";
import { toast }               from "react-toastify";
import { Modal, Button }       from "react-bootstrap";
import useUserLanguage         from "../../hooks/useUserLanguage";
import useTranslations         from "../../hooks/useTranslations";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` }
});
const API = `${process.env.REACT_APP_API_BASE_URL}/api/processing/skills`;
export default function LeadsHeader() {
  const lang             = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d="") => translations[k] || d;

  // modal açık/kapalı, filtre değerleri, combo seçenekleri
  const [show, setShow]   = useState(false);
  const [filter, setFilter] = useState({ institution:"", class:"", year:"" });
  const [instOpts, setInstOpts]   = useState([]);
  const [classOpts, setClassOpts] = useState([]);
  const [yearOpts, setYearOpts] = useState([]);

  // kurum & sınıf seçeneklerini çek
useEffect(() => {
  (async () => {
    try {
      const [iRes, cRes, yRes] = await Promise.all([
        axios.get(`${API_BASE}/api/institution/list`,      authHeaders()),
        axios.get(`${API_BASE}/api/class/list`,            authHeaders()),
        axios.get(`${API_BASE}/api/education-years/list`,  authHeaders()), // 👈
      ]);
      setInstOpts(iRes.data);
      setClassOpts(cRes.data);
      setYearOpts(yRes.data);          // 👈
    } catch (err) {
      console.error(err);
    }
  })();
}, []);

  // blob → download helper
  const saveBlob = (data, fileName) => {
    const blob = new Blob([data]);
    const url  = window.URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  // 1) Tüm PDF
  const downloadAllPDF = async () => {
    try {
      const { data } = await axios.get(
        `${API_BASE}/api/processing/skills/report/all-students`,
        { ...authHeaders(), responseType:"blob" }
      );
      saveBlob(data, "all_student_skill_reports.zip");
    } catch (e) {
      console.error(e);
      toast.error(t("DOWNLOAD_ERROR","Rapor indirilemedi"));
    }
  };

  // 2) Tüm Excel
  const downloadAllExcel = async () => {
    try {
      const { data } = await axios.get(
        `${API_BASE}/api/processing/skills/report/excel-by-student-filtered`,
        { ...authHeaders(), responseType:"blob" }
      );
      saveBlob(data, "all_skill_reports_by_student.zip");
    } catch (e) {
      console.error(e);
      toast.error(t("DOWNLOAD_EXCEL_ERROR","Excel indirilemedi"));
    }
  };

  // ortak QS yapıcı
  const makeQS = () =>
    new URLSearchParams({
      institution_id: filter.institution || undefined,
      class_id      : filter.class       || undefined,
      education_year: filter.year        || undefined
    }).toString();

  // 3) Filtreli PDF
  const downloadFilteredPDF = async () => {
    try {
      toast.info(t("DOWNLOAD_START", "PDF indiriliyor..."));
      const qs = makeQS();
      const { data } = await axios.get(
        `${API}/report?${qs}`,
        { ...authHeaders(), responseType:"blob" }
      );
      saveBlob(data, "filtered_skill_reports.pdf.zip");
      toast.success(t("DOWNLOAD_OK","PDF başarıyla indirildi."));
      setShow(false);
    } catch (e) {
      console.error(e);
      toast.error(t("DOWNLOAD_ERROR","PDF indirilemedi"));
    }
  };

// Modal’dan filtreli Excel
  const downloadFilteredExcel = async () => {
    const qs = new URLSearchParams({
      institution_id: filter.institution || undefined,
      class_id:       filter.class       || undefined,
      education_year: filter.year        || undefined
    }).toString();
    try {
      toast.info(t("DOWNLOAD_START_EXCEL", "Excel indiriliyor..."));
      const { data } = await axios.get(`${API}/report/excel-by-student-filtered?${qs}`, {
        ...authHeaders(), responseType: "blob"
      });
      saveBlob(data, "filtered_skill_reports.xlsx.zip");
      toast.success(t("DOWNLOAD_OK", "Excel başarıyla indirildi."));
      setShow(false);
    } catch {
      toast.error(t("DOWNLOAD_EXCEL_ERROR", "Excel indirilemedi"));
    }
  };

  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        <Link to="/form/reader/create" className="btn btn-primary">
          <FiPlus className="me-2" /> {t("ROLE_CREATE_TITLE","Yeni Form Oku")}
        </Link>

        <button className="btn btn-warning" onClick={()=>setShow(true)}>
          <FiFilter className="me-2" /> {t("DOWNLOAD_FILTER","Filtreli Rapor İndir")}
        </button>

        {/*<button className="btn btn-success" onClick={downloadAllExcel}>
          <FiDownload className="me-2" /> {t("DOWNLOAD_EXCEL_REPORTS","Excel Dosyası İndir")}
        </button>

        <button className="btn btn-danger" onClick={downloadAllPDF}>
          <FiDownload className="me-2" /> {t("DOWNLOAD_ALL_REPORTS","Tüm Raporları İndir")}
        </button>*/}
      </div>

      <Modal show={show} onHide={()=>setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("FILTER_MODAL_TITLE","Rapor Filtrele")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Kurum */}
          <div className="mb-3">
            <label className="form-label fw-bold">{t("INSTITUTION","Kurum")}</label>
            <select
              className="form-select"
              value={filter.institution}
              onChange={e=>setFilter({...filter, institution:e.target.value})}
            >
              <option value="">{t("ALL","Tümü")}</option>
              {instOpts.map(o=>(
                <option key={o.id} value={o.id}>{o.title}</option>
              ))}
            </select>
          </div>

          {/* Sınıf */}
          <div className="mb-3">
            <label className="form-label fw-bold">{t("CLASS","Sınıf")}</label>
            <select
              className="form-select"
              value={filter.class}
              onChange={e=>setFilter({...filter, class:e.target.value})}
            >
              <option value="">{t("ALL","Tümü")}</option>
              {classOpts.map(o=>(
                <option key={o.id} value={o.id}>{o.title||o.name}</option>
              ))}
            </select>
          </div>

          {/* Eğitim Yılı */}
          <div className="mb-3">
            <label className="form-label fw-bold">{t("EDU_YEAR","Eğitim Yılı")}</label>
            <select
              className="form-select"
              value={filter.year}
              onChange={e => setFilter({ ...filter, year: e.target.value })}
            >
              <option value="">{t("ALL","Tümü")}</option>
              {yearOpts.map(o => (
                <option key={o.id} value={o.id}>
                  {o.title || o.name /* örn. "2024-2025" */}
                </option>
              ))}
            </select>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>setShow(false)}>
            {t("CANCEL","İptal")}
          </Button>
          <Button className="btn btn-danger" onClick={downloadFilteredPDF}>
            <FiDownload className="me-1" /> {t("DOWNLOAD_PDF","PDF İndir")}
          </Button>
          <Button className="btn btn-success" onClick={downloadFilteredExcel}>
            <FiDownload className="me-1" /> {t("DOWNLOAD_EXCEL","Excel İndir")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
